<template>
    <v-select
            :disabled="disabled"
            :item-text="itemText"
            :item-value="itemValue"
            :items="items"
            :label="label"
            clearable
            dense
            outlined
            v-model="innerModel"
            hide-details
    >
    </v-select>
</template>

<script>
    export default {
        name: "SearchSingleSelectBox",
        props: {
            value: undefined,
            items: Array,
            label: {
                type: String,
                default: "Select Items",
            },
            itemValue: {
                type: String,
                default: "codeKey"
            },
            itemText: {
                type: String,
                default: "codeValue"
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                innerModel: null,
            }
        },
        watch: {
            innerModel(newValue, oldValue) {
                if (this.checkDirty(newValue, oldValue) !== true) return;
                this.$emit('input', newValue);
                this.$emit('update:selected', newValue);
            },
            value(newValue, oldValue) {
                if (this.checkDirty(newValue, oldValue) !== true) return;
                this.innerModel = newValue;
            }
        },
        methods: {
            checkDirty(newValue, oldValue) {
                if (newValue === undefined && oldValue !== undefined) return true;
                if (newValue === oldValue) return false;
                if (this.items.filter(e => e[this.itemValue] === newValue).length < 1) return false;
                return true;
            },
        },
    }
</script>

<style scoped>
    >>> input:read-only, >>> input {
        background-color: transparent !important;
        border: 0 !important;
    }
</style>